<template>
	<div class="welcome-banner">
		<p class="welcome-banner__time-greeting">{{ greeting }}</p>
		<h2 class="welcome-banner__user-headline">
			Welcome back, {{ firstName }}!
			<img src="../../assets/images/wave-hand.svg" alt="wave" class="welcome-banner__wave-icon" />
		</h2>
		<p class="welcome-banner__assignment-summary">
			You have
			<strong>{{ assignmentsDue }} {{ assignmentsDue === 1 ? "assignment" : "assignments" }}</strong>
			due this week. {{ assignmentsDue ? "Let's get to work!" : "Keep up the great work!" }}
		</p>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "DashboardWelcomeBanner",
	props: {
		firstName: String,
	},
	computed: {
		...mapState("content", ["upcomingAssignmentContents"]),

		greeting() {
			const hour = new Date().getHours();
			if (hour < 12) return "Good morning";
			if (hour < 17) return "Good afternoon";
			return "Good evening";
		},

		assignmentsDue() {
			if (!this.upcomingAssignmentContents) return 0;

			const today = new Date();
			const nextWeek = new Date();
			nextWeek.setDate(today.getDate() + 7);

			return this.upcomingAssignmentContents.filter((item) => {
				if (item.type !== "Assignment") return false;
				if (item.availabilityStatus !== "OnGoing") return false;
				const availableTo = new Date(item.availableTo);
				return availableTo >= today && availableTo <= nextWeek;
			}).length;
		},
	},
};
</script>

<style scoped>
.welcome-banner {
	background: linear-gradient(135deg, #c0392b 0%, #dc2626 60%, #e53e3e 100%);
	border-radius: 14px;
	padding: 28px 32px;
	color: #fff;
	margin-bottom: 20px;
}
.welcome-banner__time-greeting {
	font-size: 13px;
	font-weight: 400;
	margin: 0 0 4px 0;
	opacity: 0.9;
}
.welcome-banner__user-headline {
	font-size: 28px;
	font-weight: 700;
	margin: 0 0 8px 0;
	line-height: 1.2;
}
.welcome-banner__assignment-summary {
	font-size: 14px;
	margin: 0;
	opacity: 0.95;
}

/* ── Wave hand icon displayed inline beside the user's name ─ */
.welcome-banner__wave-icon {
	width: 32px;
	height: 32px;
	vertical-align: middle;
	margin-left: 6px;
}
@media (max-width: 768px) {
	.welcome-banner {
		padding: 20px 18px;
		border-radius: 10px;
		margin-top: 16px;
	}

	.welcome-banner__user-headline {
		font-size: 22px;
	}
}
</style>
